<template>
	<AnemicButton :loading="loading" @click.stop="saveIdea" tile class="pa-0 save-button">
		<SIcon height="14" width="12" class="mr-2" name="save-idea" /> Save idea
	</AnemicButton>
</template>

<script>
import { saveIdeaToAccount } from '@/store/modules/inspirationCenter/actions';
import { mapActionsShorthand } from '@/store/utils/mappers';

export default {
	name: 'SaveIdeaButton',
	props: { ideaId: { type: String }, focusIdeaOnSave: { type: Boolean } },
	methods: {
		...mapActionsShorthand({ saveIdeaToAccount }),
		async saveIdea() {
			this.loading = true;
			try {
				await this.saveIdeaToAccount({ ideaId: this.ideaId, focusOnIdea: this.focusIdeaOnSave });
			} finally {
				this.loading = false;
			}
		},
	},
	data() {
		return {
			loading: false,
		};
	},
};
</script>

<style scoped lang="scss">
.save-button {
	height: 40px !important;
	width: 100% !important;
	font-size: 14px !important;
	color: #6964eb !important;
	border-radius: 7px !important;
	font-weight: normal !important;
	letter-spacing: 0px !important;
	background: var(--white) !important;
	border: 1px solid #6964eb !important;
}
</style>
